<template>
    <div >
        <NavBar trash="true" noleft="true" />
        <ProjectTrashList />
    </div>
</template>

<script>
import NavBar           from "../NavBar";
import ProjectTrashList from "../PLComponents/ProjectTrashList";

export default {
    name: "ProjectsTrash.vue",
    components:{
        NavBar,
        ProjectTrashList
    },
    created() {
        this.$vuetify.theme.dark = true;
    }
};
</script>
